export const DEV_IPS = {
	'localhost': 'http://172.28.90.221:8000',
	'staging': 'https://furmanrecords.com/dj',
};
// dev
export const env = 'staging';